export default __webpack_public_path__ + "static/media/SG-PSA-2021.13d52239.pdf";